enum SupportRequest {
  None,
  BrowserChecklist,
  ManageCertificates,
  Troubleshooting,
}

export default SupportRequest;
